import { Clock, Hourglass } from "lucide-react";
import type { ReactNode } from "react";

import type { GroupDetail } from "@/types/api";
import { t } from "@/i18n/pl";
import { formatDays, formatTime } from "@/lib/format";

interface PendingRequestCardProps {
  group: GroupDetail;
  /** The action for this context: "Szczegóły" on the home screen, "Wycofaj" on the group page. */
  action: ReactNode;
}

/**
 * A pending join request, with what the requester actually asked for — days,
 * times and their own note — so they can check it while the driver decides.
 */
export function PendingRequestCard({ group, action }: PendingRequestCardProps) {
  return (
    <div className="animate-in fade-in slide-in-from-bottom-2 bg-accent/60 flex flex-col gap-3 rounded-xl border p-4 duration-500">
      <div className="flex items-center gap-3">
        <Hourglass
          className="text-accent-foreground size-5 shrink-0"
          aria-hidden
        />
        <p className="flex-1 text-sm font-medium">
          {t.home.requestPending(group.driver.full_name)}
        </p>
      </div>
      <div className="bg-card/70 flex flex-col gap-1 rounded-lg px-3 py-2 text-sm">
        <p className="text-muted-foreground text-xs font-semibold tracking-wide uppercase">
          {t.home.requestSummary}
        </p>
        <p className="flex flex-wrap items-center gap-x-3 gap-y-1 tabular-nums">
          <strong className="text-primary">
            {formatDays(group.my_membership_days ?? [])}
          </strong>
          <span className="flex items-center gap-1.5">
            <Clock className="size-3.5" aria-hidden />{" "}
            {formatTime(group.departure_time)} – {formatTime(group.return_time)}
          </span>
        </p>
        {group.my_request_message && (
          <p className="text-muted-foreground italic">
            „{group.my_request_message}”
          </p>
        )}
      </div>
      <div className="flex justify-end">{action}</div>
    </div>
  );
}
